const templateGame = {
    name: "Game not found",
    surname: "404",
    price: "??.??",
    desc: 'The game you tried to look for has not been found within our database. You can find a full list of our featured games in the browse section on our shop. Click the Store button in the top left corner to get back to the browse section. To avoid similar issues in the future, please do not try to access game pages by typing game names into the URL. The game might be called slightly different in our database, resulting in an error when trying to fetch the page data.',
    link: 'https://gianlucajahn.github.io/react-ecommerce-store/browse',
    release: 'No release date found',
    platforms: 'None',
    genre: 'None',
    developers: 'None',
    publishers: 'None',
    inCart: false,
    selected: false,
    isHovered: false,
    isLiked: false,
    rating: 0,
    id: 33,
    cover: "https://res.cloudinary.com/gianlucajahn/image/upload/c_scale,q_100,w_500/v1658843471/questionmark_wzexkq.png",
    footage: [
        "https://res.cloudinary.com/gianlucajahn/image/upload/v1658843471/questionmark_wzexkq.png",
        "https://res.cloudinary.com/gianlucajahn/image/upload/v1658843471/questionmark_wzexkq.png",
        "https://res.cloudinary.com/gianlucajahn/image/upload/v1658843471/questionmark_wzexkq.png",
        "https://res.cloudinary.com/gianlucajahn/image/upload/v1658843471/questionmark_wzexkq.png"
    ]
}

export default templateGame;